import auth from "./entities/auth.js";
import consent from "./entities/consent.js";
import crew from "./entities/crew.js";
import economosList from "./entities/economosList.js";
import economosMetrics from "./entities/economosMetrics.js";
import economosMovement from "./entities/economosMovement.js";
import houseItem from "./entities/houseItem.js";
import houseItemCategory from "./entities/houseItemCategory.js";
import houseItemList from "./entities/houseItemList.js";
import houseTask from "./entities/houseTask.js";
import plan from "./entities/plan.js";
import recipe from "./entities/recipe.js";
import settings from "./entities/settings.js";
import splitExpense from "./entities/splitExpense.js";
import splitExpenseGroup from "./entities/splitExpenseGroup.js";

export const endpoints = {
	auth,
	consent,
	crew,
	plan,
	recipe,
	settings,
	houseTask,
	houseItem,
	houseItemCategory,
	houseItemList,
	economosList,
	economosMetrics,
	economosMovement,
	splitExpenseGroup,
	splitExpense,
};
